import React from 'react'
import { Card } from 'react-bootstrap'

const RatingPromptCard = ({
    children
}) => {
    return (
        <div
            style={{
                position: 'fixed',
                left: '0',
                bottom: '0',
                width: '100%',
                textAlign: 'center',
                marginBottom: '55px',
            }}
        >
            <Card>
                <Card.Header>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        {children}
                    </div>
                </Card.Header>
            </Card>
        </div>
    )
}

export default RatingPromptCard